export const localStorageService = {
    set<T>(key: string, value: T): void {
        try {
            if (typeof value === "string") {
                localStorage.setItem(key, value);
            } else {
                localStorage.setItem(key, JSON.stringify(value));
            }
        } catch (error) {
            console.error(`Error saving ${key} to localStorage`, error);
        }
    },

    get<T>(key: string): T | null {
        try {
            const item = localStorage.getItem(key);
            return item ? (JSON.parse(item) as T) : null;
        } catch (error) {
            console.error(`Error reading ${key} from localStorage`, error);
            return null;
        }
    },

    remove(key: string): void {
        try {
            localStorage.removeItem(key);
        } catch (error) {
            console.error(`Error removing ${key} from localStorage`, error);
        }
    },

    clear(): void {
        try {
            localStorage.clear();
        } catch (error) {
            console.error("Error clearing localStorage", error);
        }
    },
};

export enum LocalStorageKey {
    INSTRUCTIONAL_VIDEO_GRID_FILTERS = "INSTRUCTIONAL_VIDEO_GRID_FILTERS",
    LANGUAGE = "LANGUAGE"
}
